/**
 * Saves a Blob as a file through a temporary link. The object URL is revoked on the next tick:
 * revoking it in the same tick as the click can cancel the download in Safari.
 */
export const saveBlob = (blob: Blob, name: string): void => {
    const url = URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.download = name;
    document.body.appendChild(link);
    link.click();
    link.remove();
    setTimeout(() => URL.revokeObjectURL(url), 0);
};
